import axiosInstance from "axiosConfig";
import { TOAST_TYPES_ENUM } from "enums";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { Toast } from "shared";
import { toast } from "react-toastify";
import { queryClient } from 'App'
import { SESSION_QUERY_KEY } from './CheckSessionHook'

export type SetSuccessorPasswordPayload = {
  email: string;
  password: string;
  passwordStrength?: "weak" | "medium" | "strong";
};

export const useSetSuccessorPassword = (
  options?: UseMutationOptions<
    any,
    Error,
    SetSuccessorPasswordPayload
  >
) => {
  return useMutation({
    mutationKey: ["successors", "setPassword"],
    mutationFn: async (payload: SetSuccessorPasswordPayload) => {
      return axiosInstance
        .post(`/successors/password`, payload)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Ustawiam hasło…",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "set-successor-password",
      });
      if (options?.onMutate) return options.onMutate(variables);
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Sprawdź swoją skrzynkę e-mail, aby potwierdzić ustawienie hasła.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "set-successor-password",
      });
      queryClient.invalidateQueries({
        predicate: (q) =>
          Array.isArray(q.queryKey) &&
          q.queryKey.includes("succession"),
      });
      if (options?.onSuccess) options.onSuccess(data, variables, context);
    },
    onError: (error: any, variables, context) => {
      queryClient.invalidateQueries({ queryKey: SESSION_QUERY_KEY })
      const status = error?.status ?? error?.response?.status;
      if (status === 422) {
        Toast({
          message:"Nieprawidłowe dane",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "set-successor-password",
        });
      } else if (status === 500) {
        Toast({
          message: "Błąd serwera",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "set-successor-password",
        });
      } else {
        toast.dismiss("set-successor-password");
      }

      if (options?.onError) options.onError(error, variables, context);
    },
  });
};
